import gql from 'graphql-tag';
import { ProductAttributeAllData } from '../fragments';

export default gql`
mutation deleteProductAttribute (
    $id: ID!
) {
    deleteProductAttribute (id: $id) {
        ...ProductAttributeAllData
    }
}
${ProductAttributeAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/deleteProductAttribute.ts